<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/audit-intern/attendance-notify-cfg-table">出勤日历提醒通知列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="通知标题"
                          prop="title">
              <el-input v-model="form.title"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入通知标题"
                        maxlength="255"
                        clearable
                        show-word-limit>
              </el-input>
            </el-form-item>
            <el-form-item label="通知内容"
                          prop="content">
              <el-input v-model="form.content"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入通知内容"
                        clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="通知时间"
                          prop="trigger_at">
              <el-date-picker class="width-max"
                              v-model="form.trigger_at"
                              type="datetime"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="通知发送的时间"
                              clearable>
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      id: 0,
      formRules: {
        title: [
          {required: true, message: '请输入通知标题', trigger: 'blur'},
          {max: 255, message: '通知标题不能超过 255 个字符', trigger: 'blur'},
        ],
        content: [
          {required: true, message: '请输入通知内容', trigger: 'blur'},
        ],
        trigger_at: [
          {required: true, message: '请选择通知时间', trigger: 'change'},
        ],
      },
      form: {
        title: '出勤设置提醒',
        content: '',
        trigger_at: null,
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getAttendanceNotifyCfgApi', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createAttendanceNotifyCfgApi', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/audit-intern/attendance-notify-cfg-table'})
        })
      })
    },
    update (id) {
      request.common('editAttendanceNotifyCfgApi', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/audit-intern/attendance-notify-cfg-table'})
        })
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/audit-intern/pages/attend-notify/InternAttendanceNotifyCfgForm.vue